import { render, staticRenderFns } from "./table_header.vue?vue&type=template&id=32f70459&"
import script from "./table_header.vue?vue&type=script&lang=js&"
export * from "./table_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports